

































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { VueEventTypes } from "@/events/AppEvent";
import { DialogTypes } from "@/libs/AppTypes";
import MovieContentsDialog from "@/components/templates/contents-dialogs/MovieContentsDialog.vue";
import {MattertagParams} from "@/interfaces/ContentsParams";
import StatementMovieDialog from "@/components/templates/contents-dialogs/StatementMovieDialog.vue";
import ProductContentsDialog from "@/components/templates/contents-dialogs/ProductContentsDialog.vue";
import ProductArticleDialog from "@/components/templates/contents-dialogs/ProductArticleDialog.vue";

@Component({
  components: {
    ProductArticleDialog,
    ProductContentsDialog,
    StatementMovieDialog,
    MovieContentsDialog
  }
})
export default class VrTagContents extends Vue {
  @Prop({ default: false }) isShown: boolean;
  @Prop( { default: null }) contents: MattertagParams;

  private dialogContents: any = {
    movie: null,
    statementMovie: null,
    product: null,
    productArticle: null
  };

  private showDialog: any = {
    movie: false,
    statementMovie: false,
    product: false,
    productArticle: false
  };


  @Watch('isShown')
  onChangeShown (newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      if (this.contents.type == DialogTypes.MOVIE) {
        this.showDialog.movie = true;
      }
      else if (this.contents.type == DialogTypes.STATEMENT_MOVIE) {
        this.showDialog.statementMovie = true;
      }
      else if (this.contents.type == DialogTypes.PRODUCT) {
        this.showDialog.product = true;
      }
      else if (this.contents.type == DialogTypes.PRODUCT_ARTICLE) {
        this.showDialog.productArticle = true;
      }
    }
  }


  @Watch('contents')
  onChangeContents (newValue: MattertagParams, oldValue: MattertagParams): void {
    if (newValue) {
      if (newValue.type == DialogTypes.MOVIE) {
        this.dialogContents.movie = newValue.movieContents;
      }
      else if (newValue.type == DialogTypes.STATEMENT_MOVIE) {
        this.dialogContents.statementMovie = newValue.movieContents;
      }
      else if (newValue.type == DialogTypes.PRODUCT) {
        this.dialogContents.product = newValue.productContents;
      }
      else if (newValue.type == DialogTypes.PRODUCT_ARTICLE) {
        this.dialogContents.productArticle = newValue.productContents;
      }
    }
  }

  /* Event Handlers */
  private onCloseDialog (): void {
    if (this.contents.type == DialogTypes.MOVIE) {
      this.showDialog.movie= false;
    }
    else if (this.contents.type == DialogTypes.STATEMENT_MOVIE) {
      this.showDialog.statementMovie = false;
    }
    else if (this.contents.type == DialogTypes.PRODUCT) {
      this.showDialog.product = false;
    }
    else if (this.contents.type == DialogTypes.PRODUCT_ARTICLE) {
      this.showDialog.productArticle = false;
    }

    setTimeout(() => {
      this.emitCloseContents();
    }, 300);
  }
  // Close Event Emit
  @Emit(VueEventTypes.CLOSE_CONTENTS)
  emitCloseContents (): void {
    /*
    if (this.contents.type == DialogTypes.MOVIE) {
      this.dialogContents.movie = null;
    }
    else if (this.contents.type == DialogTypes.STATEMENT_MOVIE) {
      this.dialogContents.statementMovie = null;
    }
    else if (this.contents.type == DialogTypes.PRODUCT) {
      this.dialogContents.product = null;
    }
    else if (this.contents.type == DialogTypes.PRODUCT_ARTICLE) {
      this.dialogContents.productArticle = null;
    }

     */
  }

}
